import React from "react";
import styled from "styled-components";

const TitleLabel = ({ title, required }) => {
  return (
    <Label>
      <div className="title-label">{title}</div>
      {required && <div className="required-input">*</div>}
    </Label>
  );
};

export default TitleLabel;

const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  .title-label {
    color: #aaa;
    font-size: 14px;
    margin-top: 10px;
  }
  .required-input {
    padding-left: 3px;
    position: relative;
    top: 5px;
    color: #f44336;
  }
`;
